import DeleteModal from 'modules/myAdvertisment/myAdvertisment/deleteModal';
import {useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

interface ManageAdProps {
  status: 'published' | 'rejected' | 'pending';
  app: 'farm' | 'wholesaler';
  guid: string;
  type: 'wanted-post';
  refetch: () => void;
}
const ManageAd = ({status, app, guid, type, refetch}: ManageAdProps) => {
  console.log('parent guid', guid);
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpenModalDelete, setIsOpenModalDelete] = useState(false);

  const isFarm = location.pathname.includes('farm');
  return (
    <div className="w-[50%] h-full flex justify-end items-end">
      {status === 'rejected' && (
        <button
          className="text-error  font-normal text-[13px]"
          onClick={() => setIsOpenModalDelete(prev => !prev)}
        >
          حذف آگهی
        </button>
      )}
      {status === 'published' && (
        <div className="flex w-full justify-around gap-2  font-normal text-[13px]">
          <button
            className="text-primary"
            onClick={() =>
              navigate(
                `/${
                  isFarm ? 'farm' : 'wholesaler'
                }/add-ad/purchase/edit/${guid}`,
              )
            }
          >
            ویرایش
          </button>
          <button
            className="text-error"
            onClick={() => setIsOpenModalDelete(prev => !prev)}
          >
            حذف آگهی
          </button>
        </div>
      )}
      <DeleteModal
        setIsopen={setIsOpenModalDelete}
        app={app}
        isOpen={isOpenModalDelete}
        delete_reason="canceled"
        type={type}
        guid={guid}
        refetch={refetch}
      />
    </div>
  );
};

export default ManageAd;
